var $ = require('jquery');

module.exports = function(el, isResult) {
  var className = isResult ? 'b-selectbox_placeholder' : 'hidden';
  return $('<span>').addClass(className).text(el.text());
}
